module.exports = __webpack_public_path__ + "static/ssb-ddb6fa071e2e857fe142d4b3277ccca9.png";